import React, { Component } from 'react';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap'


export class NavBarFooter extends Component {
    render() {
        return (
            <nav className="navbar fixed-bottom justify-content-center border-top border-primary ">
                <div className="footer">
                    <p className="text-muted">Copyright &copy; {new Date().getFullYear()} <a className="copyright" target="_blank" href="https://cedartreesolutions.com">Cedartree Solutions, LLC.</a></p>
                </div>
            </nav>
        )
    }
}

export default NavBarFooter
